module.exports = __webpack_public_path__ + "media/images/meta-image-603d9c99f903c8dcb9ef20c6f54e3694.png";